<template>
  <div>
    <PanelRow>
      <Panel class="two-thirds">
        <h1 slot="header">{{ 'titles.users' | trans }}</h1>
        <nav class="controls-bar" slot="header">
          <DebouncedSearch v-model="search" />
          <ButtonSwitch
            v-if="apptokenLimitOpts"
            v-model="noApptokenLimit"
            :options=apptokenLimitOpts
            classname="lg"
          />
        </nav>
        <UserList v-if="list"
          :fields=fields
          :items=list.list
          :url=itemurl
         />
        <Pages v-model="p" :pages=pages />
      </Panel>
    </PanelRow>
  </div>
</template>

<script>
  import {async} from '@/helpers/mixins/pagination'
  import List from '@/helpers/components/display/Listtwo.vue'
  import Map from '@/helpers/components/display/Map'
  import DebouncedSearch from '@/helpers/components/interact/DebouncedSearch.vue'
  import ButtonSwitch from '@/helpers/components/interact/ButtonSwitch.vue'
  import {users as fields} from '../users/fieldstwo'
  import _ from 'lodash'

  export default {
    name: 'List',
    mixins: [async],
    components: {UserList: List, DebouncedSearch, ButtonSwitch, Map},
    data () {return {
      search: '',
      noApptokenLimit: 1,
      fields: _.pick(fields, ['id', 'company_name', 'company_vat', 'userfname','userlname', 'company_contact_email', 'created_at']),
      itemurl: (item) => ( {name: 'admin.companyprofile', params:{id:item.id}}),
    }},
    computed: {
      apptokenLimitOpts () {
        if (
          this.$store.getters.admin &&
          this.$store.getters.apptoken &&
          this.$store.getters.apptoken.length
        ) {
          return {
            1: this.$t('users:admin_limit.all'),
            0: this.$t('users:admin_limit.limited', {
                apptoken: this.$store.getters.apptoken.company_name
              }),
          };
        }
      },
      baseurl () {
        if (!this.$store.getters.apptoken) {
          return null;
        }
        var base;
        if (this.noApptokenLimit && this.$store.getters.admin) {
          base = 'getcompanies';
        } else {
          base = 'apptokens/' + this.$store.getters.apptoken.id + '/users';
        }
        return base +
          '?q=' + encodeURIComponent(this.search) +
          '&sort=id::desc';
      },
    },
    asyncComputed: {
      mapUsers () {
        return this.async('apptoken')
          .then(token => this.api.post('statistics/locations/users', {
            apptokens_id: token.id,
          }))
          .then(data => 
            data.statistics_users_locations &&
            data.statistics_users_locations.coordinates ||
            []
          )
        ;
      },
    },
    methods: {
      click (latlng) {
        if (this.$store.getters.admin) {
          return;
        }
        this.api.get(
            'apptokens/' + this.$store.getters.apptoken.id + '/users' +
              '?filter=locations.latitude::eq::' + latlng.lat +
              ',locations.longitude::eq::' + latlng.lng +
              '&include=locations'
          )
        .then(users => {
          if (users.length) {
            this.$router.push({
              name: 'users.show',
              params: {id: users.id},
            });
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/sections/general/Companies.vue